import { FoodAlcoholContentModel } from './foodAlcoholContentModel';

export class FoodAlcoholModel {
  public foodAlcoholId: number;
  public foodAlcoholNameEN: string;
  public foodAlcoholNameBG: string;
  public description: string;
  public foodAlcoholContent: Array<FoodAlcoholContentModel>;
}